import { Box } from '@mui/material';
import styles from './SelectFranchise.module.scss';
import classNames from 'classnames/bind';
import { FranchiseIcon } from '~/assets/icons';
import BaseSelect from '~/components/common/base-select/BaseSelect';
import { SelectOption, SelectOptions } from '~/utils/types/franchise';
import { useEffect, useState } from 'react';
import { useAppSelector } from '~/redux/hooks';
import { StorageEnum } from '~/utils/enum';

export type SelectFranchiseProps = {
  name?: string;
  label?: string;
  options?: SelectOptions;
  value?: string;
};

const cx = classNames.bind(styles);

const SelectFranchise = (props: SelectFranchiseProps) => {
  //#region Destructuring Props
  const { ...restProps } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { companies } = useAppSelector((state) => state.company);

  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State

  const [value, setValue] = useState<string>();

  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (props.value) setValue(props.value);
  }, [props.value]);
  //#endregion Implement Hook

  //#region Handle Function
  const renderFranchiseComponent = (item: SelectOption) => {
    return <Box className={cx('franchise')}>{item.name}</Box>;
  };

  const handleSelectFranchise = (id: string) => {
    localStorage.setItem(StorageEnum.COMPANY_ID, id);
    setValue(id);
    window.location.href = '/admin/dashboard';
  };
  //#endregion Handle Function

  const renderSelectedFranchiseComponent = (item: SelectOption) => {
    return (
      <Box className={cx('franchise')}>
        <FranchiseIcon className='w-[18px] h-[18px]' />
        {item.name}
      </Box>
    );
  };

  return (
    <>
      <BaseSelect
        {...restProps}
        onChange={(e) => handleSelectFranchise(e.target.value)}
        value={value}
        menuClassName={cx('select-franchise-menu')}
        options={companies}
        renderSelected={(item: SelectOption) => renderSelectedFranchiseComponent(item)}
        renderOptionItem={(item: SelectOption) => renderFranchiseComponent(item)}
      />
    </>
  );
};

export default SelectFranchise;
